module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminusers/adminusers.component.scss
// module id = ./src/app/adminusers/adminusers.component.scss
// module chunks = main